import {
  FetchSelfCheckInAppointment,
  FetchSelfCheckInAppointmentVariables,
} from 'types/graphql'

import { TypedDocumentNode, useQuery } from '@cedarjs/web'

const QUERY: TypedDocumentNode<
  FetchSelfCheckInAppointment,
  FetchSelfCheckInAppointmentVariables
> = gql`
  query FetchSelfCheckInAppointment(
    $appointmentId: String!
    $appointmentNotificationId: String
  ) {
    selfCheckInAppointment(
      appointmentId: $appointmentId
      appointmentNotificationId: $appointmentNotificationId
    ) {
      appointmentId

      id
      status
      start
      tenantId
      logoUrl
      tenantSettings {
        id
        minimumMinorAge
        allowSelfCheckInInsuranceAgeThresholdInDays
        allowPatientInsuranceUpdateDuringCheckIn
      }
      patientRegistrationIntentId
      patientName
      patientDateOfBirth
      patientCheckInCompletedAt
      canCheckIn
      canConfirmOrReschedule
      locationName
      locationAddress
      locationPhoneNumber
      practiceName
      practiceWebsiteUrl
      confirmedAt
      appointmentTypes
      practitionerName
      patientId
      featureToggles
      requiresInsuranceReviewTask
      usesInsuranceReviewAgent
      notificationSentTo {
        patientId
        patientLegalStatus
        relatedPersonId
        name
        relationshipToPatient
        guardianshipType
      }
      requiredPracticeForms {
        id
        formSchemas
        richTextContent
        practiceFormDefinition {
          id
          classificationSubType
        }
        binary {
          content {
            url
            contentType
          }
        }
      }
    }
  }
`

export const useSelfCheckInAppointment = ({
  appointmentId,
  appointmentNotificationId,
  skip,
}: {
  appointmentId: string
  appointmentNotificationId?: string
  skip?: boolean
}) =>
  useQuery<FetchSelfCheckInAppointment, FetchSelfCheckInAppointmentVariables>(
    QUERY,
    {
      variables: { appointmentId, appointmentNotificationId },
      skip,
    }
  )
